/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $StandingSignalCreate = {
    properties: {
        matchDay: {
            type: 'number',
            isRequired: true,
        },
        userText: {
            type: 'string',
            isRequired: true,
        },
        leagueId: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
